module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"perUnit":"/ {step} {unit}","piece":"KG","startsFrom":"Starts From"},"ar":{"perUnit":"/ {step} {unit}","piece":"KG","startsFrom":"يبدأ من "}}')
  delete Component.options._Ctor
}
